import { Link, useLocation } from 'react-router-dom';
import { ReactNode, MouseEvent } from 'react';

interface AuthRequiredLinkProps {
  to: string;
  children: ReactNode;
  className?: string;
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
  [key: string]: any;
}

// Basic認証が必要なページのリスト
const AUTH_REQUIRED_PATHS = [
  '/',
  '/contact',
];

// パスが認証が必要かどうかを判定
function isAuthRequired(path: string): boolean {
  // 完全一致または、/schools/で始まるパス
  if (AUTH_REQUIRED_PATHS.includes(path)) {
    return true;
  }
  // /schools/:schoolId パターン
  if (path.startsWith('/schools/')) {
    return true;
  }
  return false;
}

/**
 * 認証が必要なページへのリンクをクリックした際に、ページをリロードするLinkコンポーネント
 * これにより、サーバー側のBasic認証チェックが実行されます
 */
export default function AuthRequiredLink({ to, children, onClick, ...props }: AuthRequiredLinkProps) {
  const location = useLocation();

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    // カスタムのonClickハンドラーがある場合は実行
    if (onClick) {
      onClick(e);
    }

    // 認証が必要なページへのリンクの場合、ページをリロード
    if (isAuthRequired(to)) {
      // 現在のパスが認証不要なページ（公開パス）の場合のみリロード
      const isPublicPath = ['/privacy-policy', '/terms-of-service', '/commercial-transactions', '/account-deletion', '/login'].includes(location.pathname);
      
      if (isPublicPath) {
        e.preventDefault();
        // クライアントサイドルーティングのフラグを設定
        sessionStorage.setItem('__lp_client_nav', 'true');
        // ページをリロードしてサーバー側のBasic認証チェックを実行
        window.location.href = to;
        return;
      }
    }
  };

  return (
    <Link to={to} onClick={handleClick} {...props}>
      {children}
    </Link>
  );
}

